import {PartialGameViewModel} from "../../../domain/partial-game/models/partial-game-view-model";

export class PreviousMeetingsWidgetUsLayoutPartialGameViewModel extends PartialGameViewModel {

  get topText(): String {
    return this.date;
  }

  get bottomText(): String {
    return this.extraDataTitle;
  }

  get scoreTimeText(): String {
    let scoreTimeText: String = this.homeCompetitor.score + ' - ' + this.awayCompetitor.score;

    if(this.isScheduled) {
      scoreTimeText = this.time;
    }

    return scoreTimeText;
  }
}
